export interface FormattedProofData {
  formattedVk: unknown;
  formattedProof: unknown;
  formattedPubs: unknown;
}
